module.exports = __webpack_public_path__ + "static/img/pd.0474fde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pd.png
// module id = l5RC
// module chunks = 1